import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { selectChatsState } from "../store/chats/selectors";
import { fetchRemindersByConversationId } from "../store/chats/thunks";

export const useReminders = () => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { chatsByTenants, selectedChatId } = useSelector(selectChatsState);

  const selectedChat = useMemo(() => {
    return chatsByTenants?.[selectedTenantId]?.[selectedChatId];
  }, [selectedChatId, selectedTenantId, chatsByTenants]);

  useEffect(() => {
    if (
      selectedChatId &&
      !selectedChat?.reminders &&
      !selectedChat?.remindersLoading
    ) {
      dispatch(
        fetchRemindersByConversationId({
          conversation_id: selectedChat?.id,
          tenant_id: selectedTenantId,
        }),
      );
    }
  }, [selectedTenantId, selectedChatId, selectedChat, dispatch]);

  return {
    loading: selectedChat?.remindersLoading,
    reminders: selectedChat?.reminders || [],
    selectedTenantId,
    selectedChatId,
  };
};
